import React from 'react';
import { useSession } from '@tap/tap-ui';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { DropdownMenu, DropdownMenuOpenButton } from '@tap/mui-ui';
import Avatar from '@mui/material/Avatar';

/*
*   Меню профиля в хедере
*/

export function ProfileMenu() {
    const userAvatarChars = undefined;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const { user, signOut } = useSession();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSignOut = () => {
        signOut();
        handleClose();
    }
    return (
        <>
            <DropdownMenuOpenButton
                primaryText={user?.userInfo?.firstName}
                secondaryText={user?.userInfo?.lastName}
                startIcon={<KeyboardArrowDownIcon sx={{ color: '#666666' }} />}
                endIcon={<Avatar>{userAvatarChars}</Avatar>}
                maxWidth={'120px'}
                margin={'0px 0px 0px 15px'}
                handleClick={handleClick}
            />

            <DropdownMenu
                id='profile-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                menuItems={[
                    { onClick: handleSignOut, label: 'Выход' },
                ]}
            />
        </>
    );
}
